import { SPageListProps } from 'servisofts-component'
import Actions from './Actions'

import Lista from './Page/Lista'
import Coach from './Page/Coach'
const Pages: SPageListProps = {
    "Audio":Lista,
    "Coach":Coach
}


import audioReducer from './Reducer/audioReducer'
const Reducers = {
    audioReducer
}


export default {
    Pages,
    Actions,
    Reducers
};